export default __webpack_public_path__ + "static/media/dog-houser-guarderia.9cce91a9.jpeg";